import type { SceneId } from '../scenes/scene.types';

export interface AppEventMap {
  'scene:entered': { sceneId: SceneId };
  'scene:left': { sceneId: SceneId };
  'hotspot:activated': { sceneId: SceneId; hotspotId: string };
  'dialogue:shown': { dialogueId: string; line: string };
  'bone:collected': { boneId: string; total: number };
  'quest:completed': Record<string, never>;
  'easter-egg:found': { eggId: string };
  'cart:changed': { count: number };
  'state:changed': Record<string, never>;
}

type Handler<K extends keyof AppEventMap> = (payload: AppEventMap[K]) => void;

const listeners = new Map<keyof AppEventMap, Set<Handler<never>>>();

export function on<K extends keyof AppEventMap>(type: K, handler: Handler<K>): () => void {
  const set = listeners.get(type) ?? new Set();
  set.add(handler as Handler<never>);
  listeners.set(type, set);
  return () => {
    set.delete(handler as Handler<never>);
  };
}

export function emit<K extends keyof AppEventMap>(type: K, payload: AppEventMap[K]): void {
  const set = listeners.get(type);
  if (!set) return;
  for (const handler of [...set]) {
    (handler as Handler<K>)(payload);
  }
}

/** Utilisé par les tests pour repartir d'un bus propre. */
export function resetEvents(): void {
  listeners.clear();
}
